module.exports = __webpack_public_path__ + "static/img/ruby.cb75cc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ruby.png
// module id = aran
// module chunks = 0